// extracted by mini-css-extract-plugin
export default {"checkboxGroup":"CheckboxGroup_checkboxGroup__o5Asx","checkboxSwitchLable":"CheckboxGroup_checkboxSwitchLable__aWdvc"};